
import platformClient from 'purecloud-platform-client-v2'
import genesysCloudService from '@/services/genesyscloud-service'
import { defineComponent } from 'vue'
import QueueSelector from '@/components/QueueSelector.vue'
import QueueDetails from '@/components/QueueDetails.vue'

export default defineComponent({
  name: 'Home',
  components: {
    QueueSelector,
    QueueDetails
  },
  data () {
    return {
      queue: {} as platformClient.Models.Queue
    }
  },
  methods: {
    async onQueueSelected (queueId: string): Promise<void> {
      this.queue = await genesysCloudService.getQueue(queueId) ?? {}
    }
  }
})
